import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { useStyles, WhiteSkeleton } from './DealerLocatorSkeleton.styles';
import { Grid, useMediaQuery, useTheme } from '@mui/material';

export const DealerLocatorSkeleton = (props: {
  isEmbedded?: boolean;
  isZipInputMobileHidden?: boolean;
}): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesMediumBreakpoint = useMediaQuery(
    theme.breakpoints.up('viewportMedium'),
    { noSsr: true }
  );
  const matchesLargeBreakpoint = useMediaQuery(
    theme.breakpoints.up('viewportLarge'),
    { noSsr: true }
  );
  return (
    <Grid container direction="row" className={classes.root}>
      {!matchesMediumBreakpoint ? ( //mobile view
        <>
          {!props.isEmbedded && (
            <div className={classes.header}>
              <Skeleton variant="text" className={classes.header_title} />
              {[...Array(3)].map((value: undefined, index: number) => (
                <Skeleton
                  variant="text"
                  key={index}
                  className={classes.header_description}
                />
              ))}
            </div>
          )}
          {!props.isZipInputMobileHidden && (
            <Skeleton variant="rectangular" className={classes.zip_input} />
          )}
          <Skeleton variant="rectangular" className={classes.filter_dropdown} />

          <Grid container direction="row" className={classes.tab_container}>
            <WhiteSkeleton
              variant="rectangular"
              className={`${classes.tab} ${classes.white_tab}`}
            />
            <Skeleton variant="rectangular" className={classes.tab} />
          </Grid>
          <Grid container direction="row">
            {[...Array(5)].map((value: undefined, index: number) => (
              <Skeleton
                variant="rectangular"
                key={index}
                className={classes.card}
              />
            ))}
          </Grid>
          <Skeleton variant="rectangular" className={classes.show_more} />
        </>
      ) : (
        // desktop view
        <>
          {!props.isEmbedded && (
            <div className={classes.header}>
              <Skeleton variant="text" className={classes.header_title} />
              {matchesLargeBreakpoint
                ? [...Array(3)].map((value: undefined, index: number) => (
                    <Skeleton
                      variant="text"
                      key={index}
                      className={classes.header_description}
                    />
                  ))
                : [...Array(1)].map((value: undefined, index: number) => (
                    <Skeleton
                      variant="text"
                      key={index}
                      className={classes.header_description}
                    />
                  ))}
            </div>
          )}
          <Grid container direction="row">
            <Grid item md={6} className={classes.dealer_container}>
              <Grid container direction="row">
                <Skeleton variant="rectangular" className={classes.zip_input} />
                <Skeleton
                  variant="rectangular"
                  className={classes.filter_dropdown}
                />
                {[...Array(props.isEmbedded ? 3 : 5)].map(
                  (value: undefined, index: number) => (
                    <Skeleton
                      variant="rectangular"
                      key={index}
                      className={classes.card}
                    />
                  )
                )}
                <Skeleton variant="rectangular" className={classes.show_more} />
              </Grid>
            </Grid>
            <Grid item md className={classes.map_container}>
              <Skeleton variant="rectangular" className={classes.map} />
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};
